export default "__VITE_ASSET__DfCxHUlj__"